import { api } from './client';
import { AxiosError } from 'axios';

const extractErrorMessage = (error: unknown, fallback: string, isArabic = false): string => {
  if (error instanceof AxiosError && error.response?.data?.error) {
    const errObj = error.response.data.error;
    if (isArabic && errObj.messageAr) return errObj.messageAr;
    if (errObj.message) return errObj.message;
  }
  return error instanceof Error ? error.message : fallback;
};

export const userApi = {
  getUsers: async () => {
    try {
      const response = await api.get('/platform/users');
      return Array.isArray(response.data) ? response.data : response.data?.items ?? response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error, 'Failed to load users'));
    }
  },

  getRoles: async () => {
    try {
      const response = await api.get('/platform/roles');
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error, 'Failed to load roles'));
    }
  },

  createUser: async (data: {
    email: string;
    password: string;
    orgId: string;
    roleIds: string[];
    firstName?: string;
    lastName?: string;
  }) => {
    try {
      const response = await api.post('/platform/users', data);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error, 'Create user failed'));
    }
  },

  updateUser: async (
    userId: string,
    data: {
      email?: string;
      password?: string;
      roleIds?: string[];
      firstName?: string;
      lastName?: string;
    },
  ) => {
    try {
      const response = await api.put(`/platform/users/${userId}`, data);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error, 'Update user failed'));
    }
  },

  deleteUser: async (userId: string) => {
    try {
      const response = await api.delete(`/platform/users/${userId}`);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error, 'Delete user failed'));
    }
  },

  updateProfile: async (data: any) => {
    const response = await api.patch('/users/me', data);
    return response.data;
  },

  changePassword: async (data: any) => {
    const response = await api.patch('/users/me/password', data);
    return response.data;
  },
};
